import { Course, Student, StudentClassesCourse, StudentCourse } from "@app/admin/model";
import { StatusClass } from "@app/shared/enum";

export class StudentClassesCourseConfirmed {
    student: Student;
    course: Course;
    studentClassesCourse: StudentClassesCourse;
    statusClass: StatusClass;
    studentCourse: StudentCourse;
}